module.exports = __webpack_public_path__ + "static/media/1POLICY49.9a5de898.jpg";